(function () {
  'use strict';

  /* Nothing to accelerate: the reveals are already off. */
  if (
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  var root = document.documentElement;

  var ENTER_FAST = 1200;
  var ENTER_RUSH = 3000;
  var EXIT_FAST = 700;
  var EXIT_RUSH = 2100;

  var LOOKAHEAD_SECONDS = 0.34;
  var LOOKAHEAD_MIN = 240;
  var LOOKAHEAD_MAX = 2600;

  var FLUSH_INTERVAL = 110; /* ms between sweeps while moving fast */
  var IDLE_MS = 150; /* no scroll event for this long means stopped */

  var FAMILIES = [
    { sel: '.blog-reveal:not(.blog-reveal--in)', cls: 'blog-reveal--in', delayVar: '--blog-reveal-delay' },
    { sel: '.cl-reveal:not(.cl-reveal--in)', cls: 'cl-reveal--in', delayVar: '--cl-reveal-delay' },
    { sel: '.hp-reveal:not(.hp-reveal--in)', cls: 'hp-reveal--in', delayVar: '--hp-reveal-delay' },
    { sel: '.hp-track:not(.hp-track--in)', cls: 'hp-track--in', delayVar: null },
    { sel: '.bs-reveal:not(.bs-reveal--in)', cls: 'bs-reveal--in', delayVar: '--bs-reveal-delay' },
    { sel: '.pdp-media-item:not(.pdp-pop)', cls: 'pdp-pop', delayVar: '--pdp-pop-delay' }
  ];

  var lastY = window.pageYOffset || 0;
  var lastT = 0;
  var velocity = 0; /* smoothed, px/s, always positive */
  var tier = '';
  var ticking = false;
  var lastEventT = 0;
  var lastFlushT = 0;

  function now() {
    return window.performance && window.performance.now
      ? window.performance.now()
      : Date.now();
  }

  function setTier(next) {
    if (next === tier) return;
    tier = next;
    if (next) {
      root.setAttribute('data-scroll-speed', next);
    } else {
      root.removeAttribute('data-scroll-speed');
    }
  }

  /* Hysteresis: the bar to enter a tier is higher than the bar to stay in it. */
  function tierFor(v) {
    if (tier === 'rush') return v >= EXIT_RUSH ? 'rush' : v >= EXIT_FAST ? 'fast' : '';
    if (tier === 'fast') {
      if (v >= ENTER_RUSH) return 'rush';
      return v >= EXIT_FAST ? 'fast' : '';
    }
    if (v >= ENTER_RUSH) return 'rush';
    if (v >= ENTER_FAST) return 'fast';
    return '';
  }

  function flush(lookahead) {
    var top = -lookahead;
    var bottom = (window.innerHeight || root.clientHeight) + lookahead;

    for (var f = 0; f < FAMILIES.length; f++) {
      var family = FAMILIES[f];
      var pending = document.querySelectorAll(family.sel);
      if (!pending.length) continue;

      for (var i = 0; i < pending.length; i++) {
        var el = pending[i];
        var rect = el.getBoundingClientRect();

        /* Zero-height elements are almost always not laid out yet; revealing
           one would burn its transition while it is still invisible. */
        if (rect.bottom === rect.top) continue;
        if (rect.top > bottom || rect.bottom < top) continue;

        if (family.delayVar) el.style.setProperty(family.delayVar, '0ms');
        el.classList.add(family.cls);
      }
    }
  }

  function frame() {
    ticking = false;

    var t = now();
    var y = window.pageYOffset || root.scrollTop || 0;
    var dt = t - lastT;

    if (dt < 4) {
      request();
      return;
    }

    if (dt > 0) {
      var instant = Math.min(20000, (Math.abs(y - lastY) / dt) * 1000);

      velocity = velocity * 0.55 + instant * 0.45;
    }

    lastY = y;
    lastT = t;

    setTier(tierFor(velocity));

    if (tier && t - lastFlushT >= FLUSH_INTERVAL) {
      lastFlushT = t;
      var lookahead = Math.max(
        LOOKAHEAD_MIN,
        Math.min(LOOKAHEAD_MAX, velocity * LOOKAHEAD_SECONDS)
      );
      try {
        flush(lookahead);
      } catch (e) {
        /* A failed sweep costs nothing: the observers still fire normally. */
      }
    }

    if (t - lastEventT < IDLE_MS || velocity > 1) {
      if (t - lastEventT >= IDLE_MS) velocity *= 0.6;
      request();
    } else {
      velocity = 0;
      setTier('');
    }
  }

  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  }

  function onScroll() {
    var t = now();

    if (t - lastEventT > IDLE_MS) {
      lastT = t;
      lastY = window.pageYOffset || root.scrollTop || 0;
    }

    lastEventT = t;
    request();
  }

  function start() {
    lastT = now();
    lastY = window.pageYOffset || 0;
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  try {
    /* A read-only handle for anything that wants to know, without having to
       measure it a second time. */
    window.AborderScrollSpeed = {
      velocity: function () {
        return velocity;
      },
      tier: function () {
        return tier;
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  } catch (e) {
    /* Every reveal on the site works without this file. */
  }
})();
